import {
  createSelector,
  MemoizedSelector
} from '@ngrx/store';
import { DigiAIXCoreAppState } from '../../app-state';
import { selectDigitaixState } from '../../core.selectors';
import { isAuthEnabled } from '../../config/config.selectors';
import { DxUser } from '@digitaix/types';

export const selectAuthState = createSelector(
  selectDigitaixState,
  state => (state && state.auth) || null
);
export const getUser: MemoizedSelector<any, DxUser | false> = createSelector(
  selectAuthState,
  state => (state && state.user) || null
);

export const isAuthenticated = createSelector(
  getUser,
  isAuthEnabled,
  (user, enabled) => !!user || enabled === false
);

export const getRouterState = (state: DigiAIXCoreAppState) =>
  state && state.router && state.router.state;

export const isAdmin = createSelector(
  getUser,
  isAuthEnabled,
  (user, enabled) =>
    !enabled || (!user ? null : user.roles && user.roles.includes('admin'))
);
